import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import OnboardingNotifications from "@/components/onboarding/OnboardingNotifications/OnboardingNotifications.vue";
import {
  OnboardingContainerTypeEnum,
  OnboardingRouteItemNameEnum,
} from "@/types/onboarding";
import { onboardingInjectionKey } from "@/utils/onboarding/onboardingInjectionKey";
import { provide } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'WelcomeNotifications',
  setup(__props) {

provide(onboardingInjectionKey, {
  type: OnboardingContainerTypeEnum.Onboarding,
  routeName: OnboardingRouteItemNameEnum.Notifications,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(OnboardingNotifications))
}
}

})